import useAuth from "../../Hooks/useAuth";

const useHeaderDropdownData = (props) => {
  const { setAuth } = useAuth();
  const { id: userId } = props?.auth?.user ?? "";
  const closeAndDropdown = () => {
    props?.setOpenSubmenuKey?.(null);
    props?.setDropDown?.(false);
  };
  const toggleSubmenu = (key) => {
    props?.setOpenSubmenuKey?.((prev) => (prev === key ? null : key));
  };

  return [
    {
      type: "link",
      label: "Dashboard",
      link: `/business-dashboard/dashboard?userId=${userId}`,
      onClick: () => props?.setDropDown?.(false),
    },
    {
      type: "link",
      label: "Public Profile",
      link: `/poster-profile?userId=${userId}`,
      onClick: () => props?.setDropDown?.(false),
    },
    {
      type: "dropdown",
      label: "Posts",
      key: "posts",
      onClick: () => toggleSubmenu("posts"),
      subMenu: [
        { type: "link", label: "Create Post", link: `/business-dashboard/posts/create-post?userId=${userId}`, onClick: closeAndDropdown },
        { type: "link", label: "Published", link: `/business-dashboard/posts/published?userId=${userId}`, onClick: closeAndDropdown },
        { type: "link", label: "Drafts", link: `/business-dashboard/posts/drafts?userId=${userId}`, onClick: closeAndDropdown },
        { type: "link", label: "Deleted", link: `/business-dashboard/posts/bin?userId=${userId}`, onClick: closeAndDropdown },
        { type: "link", label: "Flagged", link: `/business-dashboard/posts/flagged?userId=${userId}`, onClick: closeAndDropdown },
      ],
    },
    {
      type: "dropdown",
      label: "Messages",
      key: "messages",
      onClick: () => toggleSubmenu("messages"),
      subMenu: [
        { type: "link", label: "All messages", link: `/business-dashboard/inbox/chats?userId=${userId}`, onClick: closeAndDropdown },
        { type: "link", label: "Deleted", link: `/business-dashboard/inbox/deleted?userId=${userId}`, onClick: closeAndDropdown },
      ],
    },
    {
      type: "dropdown",
      label: "Quotes",
      key: "quotes",
      onClick: () => toggleSubmenu("quotes"),
      subMenu: [
        { type: "link", label: "All quotes", link: `/business-dashboard/inbox/quotes?userId=${userId}`, onClick: closeAndDropdown },
        { type: "link", label: "Deleted", link: `/business-dashboard/inbox/deleted?userId=${userId}`, onClick: closeAndDropdown },
      ],
    },
    {
      type: "link",
      label: "Reviews",
      link: `/business-dashboard/inbox/reviews?userId=${userId}`,
      onClick: () => props?.setDropDown?.(false),
    },
    {
      type: "link",
      label: "Subscription",
      link: `/business-dashboard/subscriptions/billing-details?userId=${userId}`,
      onClick: () => props?.setDropDown?.(false),
    },
    {
      type: "dropdown",
      label: "Account",
      key: "account",
      onClick: () => toggleSubmenu("account"),
      subMenu: [
        { type: "link", label: "Profile", link: `/business-dashboard/settings/account?userId=${userId}`, onClick: closeAndDropdown },
        { type: "link", label: "Portfolio", link: `/business-dashboard/settings/manage-portfolio?userId=${userId}`, onClick: closeAndDropdown },
        { type: "link", label: "Compliance", link: `/business-dashboard/settings/certifications?userId=${userId}`, onClick: closeAndDropdown },
        { type: "link", label: "Security", link: `/business-dashboard/settings/security-verification?userId=${userId}`, onClick: closeAndDropdown },
        { type: "link", label: "Preferences", link: `/business-dashboard/settings/notification-preferences?userId=${userId}`, onClick: closeAndDropdown },
      ],
    },
    {
      type: "dropdown",
      label: "Tickets",
      key: "tickets",
      onClick: () => toggleSubmenu("tickets"),
      subMenu: [
        { type: "link", label: "Create ticket", link: `/business-dashboard/tickets/create?userId=${userId}`, onClick: closeAndDropdown },
        { type: "link", label: "Open", link: `/business-dashboard/tickets/open?userId=${userId}`, onClick: closeAndDropdown },
        { type: "link", label: "Resolved", link: `/business-dashboard/tickets/resolved?userId=${userId}`, onClick: closeAndDropdown },
        { type: "link", label: "Closed", link: `/business-dashboard/tickets/closed?userId=${userId}`, onClick: closeAndDropdown },
      ],
    },
    {
      type: "dropdown",
      label: "Help Center",
      key: "help",
      onClick: () => toggleSubmenu("help"),
      subMenu: [
        { type: "link", label: "Help Centre", link: `/HelpCentre`, onClick: closeAndDropdown },
        { type: "link", label: "Terms & Policy", link: `/terms-&-conditions`, onClick: closeAndDropdown },
      ],
    },
    {
      type: "link",
      label: "Log out",
      link: "/",
      onClick: () => {
        localStorage.removeItem("LoginSession");
        setAuth({ user: null, roles: null, accessToken: "" });
        props?.setDropDown?.(false);
      },
    },
  ];
};

// Mobile dropdown – same structure as sidebar (used when Navbar shows logged-in menu)
const useMobileDropdownData = (props) => {
  const { setAuth } = useAuth();
  const { id: userId } = props?.auth?.user ?? "";
  const closeAll = () => {
    props?.setPostingOpen?.(false);
    props?.setSubsOpen?.(false);
    props?.setListOpen?.(false);
    props?.setInboxOpen?.(false);
    props?.setHelpOpen?.(false);
    props?.setQuotesOpen?.(false);
    props?.setTicketsOpen?.(false);
  };
  const closeAndDrawer = () => {
    closeAll();
    props?.safeToggleDrawer?.();
  };

  return [
    {
      type: "link",
      label: "Dashboard",
      link: `/business-dashboard/dashboard?userId=${userId}`,
      onClick: closeAndDrawer,
    },
    {
      type: "link",
      label: "Public Profile",
      link: `/poster-profile?userId=${userId}`,
      onClick: closeAndDrawer,
    },
    {
      type: "dropdown",
      label: "Posts",
      key: "posts",
      onClick: () => {
        props?.setPostingOpen?.(!props?.postingOpen);
        closeAll();
        if (!props?.postingOpen) props?.setPostingOpen?.(true);
      },
      subMenu: [
        { type: "link", label: "Create Post", link: `/business-dashboard/posts/create-post?userId=${userId}`, onClick: closeAndDrawer },
        { type: "link", label: "Published", link: `/business-dashboard/posts/published?userId=${userId}`, onClick: closeAndDrawer },
        { type: "link", label: "Drafts", link: `/business-dashboard/posts/drafts?userId=${userId}`, onClick: closeAndDrawer },
        { type: "link", label: "Deleted", link: `/business-dashboard/posts/bin?userId=${userId}`, onClick: closeAndDrawer },
        { type: "link", label: "Flagged", link: `/business-dashboard/posts/flagged?userId=${userId}`, onClick: closeAndDrawer },
      ],
    },
    {
      type: "dropdown",
      label: "Messages",
      key: "messages",
      onClick: () => {
        props?.setInboxOpen?.(!props?.inboxOpen);
        closeAll();
        if (!props?.inboxOpen) props?.setInboxOpen?.(true);
      },
      subMenu: [
        { type: "link", label: "All messages", link: `/business-dashboard/inbox/chats?userId=${userId}`, onClick: closeAndDrawer },
        { type: "link", label: "Deleted", link: `/business-dashboard/inbox/deleted?userId=${userId}`, onClick: closeAndDrawer },
      ],
    },
    {
      type: "dropdown",
      label: "Quotes",
      key: "quotes",
      onClick: () => {
        props?.setQuotesOpen?.(!props?.quotesOpen);
        closeAll();
        if (!props?.quotesOpen) props?.setQuotesOpen?.(true);
      },
      subMenu: [
        { type: "link", label: "All quotes", link: `/business-dashboard/inbox/quotes?userId=${userId}`, onClick: closeAndDrawer },
        { type: "link", label: "Deleted", link: `/business-dashboard/inbox/deleted?userId=${userId}`, onClick: closeAndDrawer },
      ],
    },
    {
      type: "link",
      label: "Reviews",
      link: `/business-dashboard/inbox/reviews?userId=${userId}`,
      onClick: closeAndDrawer,
    },
    {
      type: "link",
      label: "Subscription",
      link: `/business-dashboard/subscriptions/billing-details?userId=${userId}`,
      onClick: closeAndDrawer,
    },
    {
      type: "dropdown",
      label: "Account",
      key: "account",
      onClick: () => {
        props?.setListOpen?.(!props?.listOpen);
        closeAll();
        if (!props?.listOpen) props?.setListOpen?.(true);
      },
      subMenu: [
        { type: "link", label: "Profile", link: `/business-dashboard/settings/account?userId=${userId}`, onClick: closeAndDrawer },
        { type: "link", label: "Portfolio", link: `/business-dashboard/settings/manage-portfolio?userId=${userId}`, onClick: closeAndDrawer },
        { type: "link", label: "Compliance", link: `/business-dashboard/settings/certifications?userId=${userId}`, onClick: closeAndDrawer },
        { type: "link", label: "Security", link: `/business-dashboard/settings/security-verification?userId=${userId}`, onClick: closeAndDrawer },
        { type: "link", label: "Preferences", link: `/business-dashboard/settings/notification-preferences?userId=${userId}`, onClick: closeAndDrawer },
      ],
    },
    {
      type: "dropdown",
      label: "Tickets",
      key: "tickets",
      onClick: () => {
        props?.setTicketsOpen?.(!props?.ticketsOpen);
        closeAll();
        if (!props?.ticketsOpen) props?.setTicketsOpen?.(true);
      },
      subMenu: [
        { type: "link", label: "Create ticket", link: `/business-dashboard/tickets/create?userId=${userId}`, onClick: closeAndDrawer },
        { type: "link", label: "Open", link: `/business-dashboard/tickets/open?userId=${userId}`, onClick: closeAndDrawer },
        { type: "link", label: "Resolved", link: `/business-dashboard/tickets/resolved?userId=${userId}`, onClick: closeAndDrawer },
        { type: "link", label: "Closed", link: `/business-dashboard/tickets/closed?userId=${userId}`, onClick: closeAndDrawer },
      ],
    },
    {
      type: "dropdown",
      label: "Help Center",
      key: "help",
      onClick: () => {
        props?.setHelpOpen?.(!props?.helpOpen);
        closeAll();
        if (!props?.helpOpen) props?.setHelpOpen?.(true);
      },
      subMenu: [
        { type: "link", label: "Help Centre", link: `/HelpCentre`, onClick: closeAndDrawer },
        { type: "link", label: "Terms & Policy", link: `/terms-&-conditions`, onClick: closeAndDrawer },
      ],
    },
    {
      type: "link",
      label: "Log out",
      link: "/",
      onClick: () => {
        setAuth({ user: null, roles: null, accessToken: "" });
        localStorage.removeItem("LoginSession");
        props?.safeToggleDrawer?.();
      },
    },
  ];
};

export { useHeaderDropdownData, useMobileDropdownData };
export default useHeaderDropdownData;
